export default [
  {
    to: "/workcompletionapproval",
    icon: "mdi-clipboard-check-outline",
    text: "作業完了承認",
    authority: [0, 1, 2, 3, 4, 5, 9]
  },
  {
    to: "/workreport",
    icon: "mdi-wrench-clock",
    text: "作業報告一覧",
    authority: [1, 2, 3, 4, 5, 9]
  },
  {
    text: "ログアウト",
    icon: "mdi-logout",
    to: "/login",
    authority: [0, 1, 2, 3, 4, 5, 9]
  }
];
